/**
 * @author - steves165
 *
 * Global variables and functions
 */

/*global angular*/

/**
 * Vhols namespace, used for event debouncing so far.
 *
 * @type {{angEl: function}}
 */


var vhols = window.vhols || {}

vhols.angEl = function(selector) {
    'use strict';

    if (typeof selector === 'string') {
        return angular.element(document.querySelectorAll(selector));
    } else {
        return angular.element(selector);
    }

};

vhols.getClosest = function (elem, selector) {
    'use strict';

    var firstChar = selector.charAt(0);

    // Get closest match
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        // If selector is a class
        if ( firstChar === '.' ) {
            var classList = elem.className.split(" ");

            if (!!~classList.indexOf(selector.substr(1))) {
                return elem;
            }
        }

        // If selector is an ID
        if ( firstChar === '#' ) {
            if ( elem.id === selector.substr(1) ) {
                return elem;
            }
        }

        // If selector is a data attribute
        if ( firstChar === '[' ) {
            if ( elem.hasAttribute( selector.substr(1, selector.length - 2) ) ) {
                return elem;
            }
        }

        // If selector is a tag
        if ( elem.tagName.toLowerCase() === selector ) {
            return elem;
        }
    }

    return false;
};

vhols.isHidden = function(elem) {
    'use strict';
    return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
};

vhols.mobileScreenWidth = 768;

vhols.unsnakecase = function(str) {
    'use strict';
    return (str.substr(0, 1).toUpperCase() + str.substr(1)).replace(/-/g, ' ');
};
